var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-print-transparent';
                    var viewUrl = 'gfx/sprite.svg#view-icon-print-transparent';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 17 16',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };